export class ColumnViewModel {
    name: string = "";
    isActive: boolean = false;
    isHidden: boolean = false;

    constructor(name: string, active: boolean, hidden: boolean = false) {
        this.name = name;
        this.isActive = active;
        this.isHidden = hidden;
    }
}